import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const LinkedWorkflowWrapper = styled.div`
  margin: ${spacing.base} 0 ${spacing.base} 0;
`;
